import { ComponentProps, ReactNode } from 'react';

import Button, { ButtonVariant } from '../../../common/button/button';

export const enum OptionVariants {
  OptionSelected,
  OptionNotSelected,
  default,
}

type Props = {
  label: ReactNode;
  image?: ReactNode;
  suffix?: string | number;
  onChange?: () => void;
  optionVariant: OptionVariants;
  optionShapeType?:
    | 'default'
    | 'noBorder'
    | 'withImage'
    | 'square'
    | 'leftImageRightText';
  extraContent?: ReactNode;
};

const SelectOption = ({
  optionVariant,
  optionShapeType = 'default',
  label,
  image,
  onChange,
  extraContent,
  ...props
}: Props & ComponentProps<typeof Button>) => {
  let variantClassName;

  switch (optionVariant) {
    case OptionVariants.OptionSelected: {
      variantClassName =
        image && optionShapeType === 'default'
          ? ButtonVariant.OPTION_BUTTON_WITH_ICON_SELECTED
          : optionShapeType === 'noBorder'
            ? ButtonVariant.OPTION_BUTTON_NO_BORDER_SELECTED
            : optionShapeType === 'withImage'
              ? ButtonVariant.OPTION_BUTTON_WITH_IMAGE_SELECTED
              : optionShapeType === 'square'
                ? ButtonVariant.OPTION_BUTTON_SQUARE_SELECTED
                : optionShapeType === 'leftImageRightText'
                  ? ButtonVariant.OPTION_BUTTON_LEFT_IMAGE
                  : ButtonVariant.OPTION_BUTTON_SELECTED;
      break;
    }
    case OptionVariants.OptionNotSelected: {
      variantClassName =
        image && optionShapeType === 'default'
          ? ButtonVariant.OPTION_BUTTON_WITH_ICON
          : optionShapeType === 'noBorder'
            ? ButtonVariant.OPTION_BUTTON_NO_BORDER
            : optionShapeType === 'withImage'
              ? ButtonVariant.OPTION_BUTTON_WITH_IMAGE_NOT_SELECTED
              : optionShapeType === 'square'
                ? ButtonVariant.OPTION_BUTTON_SQUARE
                : optionShapeType === 'leftImageRightText'
                  ? ButtonVariant.OPTION_BUTTON_LEFT_IMAGE_NOT_SELECTED
                  : ButtonVariant.OPTION_BUTTON;
      break;
    }
    default: {
      variantClassName =
        image && optionShapeType === 'default'
          ? ButtonVariant.OPTION_BUTTON_WITH_ICON
          : optionShapeType === 'noBorder'
            ? ButtonVariant.OPTION_BUTTON_NO_BORDER
            : optionShapeType === 'withImage'
              ? ButtonVariant.OPTION_BUTTON_WITH_IMAGE
              : optionShapeType === 'square'
                ? ButtonVariant.OPTION_BUTTON_SQUARE
                : optionShapeType === 'leftImageRightText'
                  ? ButtonVariant.OPTION_BUTTON_LEFT_IMAGE
                  : ButtonVariant.OPTION_BUTTON;
    }
  }

  return (
    <Button
      IconComponent={image}
      type="button"
      onClick={() => onChange?.()}
      variant={variantClassName}
      {...props}>
      {extraContent}

      {label}
    </Button>
  );
};

export default SelectOption;
